import axios from 'axios';

// const API_BASE_URL = 'http://localhost:3000/api';
const API_BASE_URL = 'https://diary.pstu.ac.bd/api';

export const clearStoredAuth = () => {
  localStorage.removeItem('pstu_diary_token');
  localStorage.removeItem('pstu_diary_user');
  sessionStorage.removeItem('pstu_diary_redirect_after_login');
};

// Create axios instance with base configuration
const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor to add auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('pstu_diary_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle auth errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Token expired or invalid, redirect to login
      clearStoredAuth();
      window.location.href = '/';
    }
    return Promise.reject(error);
  }
);

export default api;

// Media upload function
export const uploadMedia = async (file) => {
  try {
    const formData = new FormData();
    formData.append('file', file);

    const response = await fetch('https://media.diary.pstu.ac.bd/upload', {
      method: 'POST',
      body: formData,
    });

    const result = await response.json();

    if (result.success) {
      return {
        success: true,
        url: result.downloadUrl
      };
    } else {
      throw new Error(result.message || 'Upload failed');
    }
  } catch (error) {
    console.error('Media upload error:', error);
    return {
      success: false,
      error: error.message || 'Upload failed'
    };
  }
};
